module.exports = __webpack_public_path__ + "static/media/Yesterday-logo.4988aa21.png";